module.exports = __webpack_public_path__ + "img/sign-57.e9d6d1b1.jpg";